import React from 'react';
import { IconProps } from './icon.types';

function IconMinus(props: IconProps) {
  const { customClassName = '', customStyle = {} } = props;

  return (
    <svg
      className={customClassName}
      style={customStyle}
      width="12"
      height="2"
      viewBox="0 0 12 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.25 1.5625H0.75C0.4395 1.5625 0.1875 1.3105 0.1875 1C0.1875 0.6895 0.4395 0.4375 0.75 0.4375H11.25C11.5605 0.4375 11.8125 0.6895 11.8125 1C11.8125 1.3105 11.5605 1.5625 11.25 1.5625Z"
        fill="#25314C"
      />
    </svg>
  );
}

export default IconMinus;
